<template>
    <div>
        <template v-if="isAuthorized">
            <v-row no-gutters class="my-3 justify-center">
                <v-col cols="2">
                    <!-- <template v-if="!accountableAccountsSelected.length"> -->
                    <v-btn-primary @click="miscellaneousOperationDialog = true" block
                        >Ajouter</v-btn-primary
                    >
                    <!-- </template>
                <template v-else>
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        :disabled="!accountableAccountsSelected.length"
                        @click="exportDialog = true"
                    >Exporter</v-btn>
                </template> -->
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '6'" class="pl-2">
                    <oss-filter-bar
                        :mode="'bankTransaction'"
                        v-model:type="type"
                        :showTypeTag="false"
                        v-model:text="search"
                        v-model:startDate="beginDate"
                        v-model:endDate="endDate"
                        :minDate="minDate"
                        :maxDate="maxDate"
                        :dateIsManadatory="true"
                        v-model:status="reconciliationStatus"
                        :minPrice="minAmount"
                        @update:minPrice="minAmount = $event + ''"
                        :maxPrice="maxAmount"
                        @update:maxPrice="maxAmount = $event + ''"
                        v-model:payBy="payBy"
                        :limitMinPrice="limitMinAmount"
                        :limitMaxPrice="limitMaxAmount"
                        :types-list="
                            documentTypes.map((type) => {
                                return { value: type, text: $t('document.type.' + type) };
                            })
                        "
                        :status-list="
                            allReconciliationStatus.map((status) => {
                                return { value: status, text: formatStatus(status) };
                            })
                        "
                        :payByList="payByList"
                        :companyId="selectedCompany.id"
                    />
                    <!-- <oss-filter-bar
                    :type="documentType" @type="documentType = $event"
                    :showTypeTag="false"
                    :text="search" @text="search = $event"
                    :tags="documentTags" @tags="setDocumentTags"
                    :startDate="beginDate" @startDate="beginDate = $event"
                    :endDate="endDate" @endDate="endDate = $event"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :status="documentStatus" @status="documentStatus = $event"
                    :showStatusTag="false"
                    :statusIsManadatory="true"
                    :dateIsManadatory="true"
                    :thirdPartyCompanyName="thirdPartyCompanyName" @thirdPartyCompanyName="thirdPartyCompanyName = $event"
                    :minPrice="minAmount" @minPrice="documentType === 'PURCHASE_INVOICE' ? maxAmount = -$event + '' : minAmount = $event + ''"
                    :maxPrice="maxAmount" @maxPrice="documentType === 'PURCHASE_INVOICE' ? minAmount = -$event + '' : maxAmount = $event + ''"
                    :limitMinPrice="documentType === 'PURCHASE_INVOICE' ? -maxDocumentAmount : minDocumentAmount"
                    :limitMaxPrice="documentType === 'PURCHASE_INVOICE' ? -minDocumentAmount : maxDocumentAmount"
                    :types-list="documentTypes.map((type) => { return { value: type, text:formatType(type) }})"
                    :status-list="allDocumentStatus.map((type) => {return {value: type, text:formatStatus(type)}})"
                    :companyId="selectedCompany.id"
                ></oss-filter-bar> -->
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Debit : ' + newCommonFormatCurrency(totalDebit, undefined)"
                        density="compact"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Crédit : ' + newCommonFormatCurrency(totalCredit, undefined)"
                        density="compact"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <oss-data-table
                :headers="headers"
                :items="items"
                v-model:page="pagination.page"
                v-model:sort-by="sortBy"
                v-model:sort-desc="pagination.descending"
                :items-length="pagination.totalItems"
                v-model:items-per-page="pagination.rowsPerPage"
                :items-per-page-options="[5, 10, 25]"
                v-model:loading="loading"
                class="table"
                hide-default-footer
                fixed-header
                height="71vh"
                style="border-collapse: collapse"
            >
                <!-- HEADER TEMPLATE -->
                <!-- <template v-slot:header>
                    <v-row no-gutters>
                        <v-col v-if="isAccountingUser">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col>
                                    <v-btn
                                        rounded
                                        color="ternary"
                                        elevation="0"
                                        :disabled="disabledWithoutInvoice"
                                        @click="
                                            showCreateBankTransactionMessageDialog =
                                                !showCreateBankTransactionMessageDialog
                                        "
                                        size="small"
                                        icon="$fa-comments"
                                    >
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        @click="
                                            companyType = 'SUPPLIER';
                                            thirdPartyDialog = !thirdPartyDialog;
                                        "
                                        rounded
                                        color="ternary"
                                        elevation="0"
                                        class="ml-2"
                                        :disabled="disabledThirdPartyCompany()"
                                        size="small"
                                    >
                                        Fournisseur
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        @click="
                                            companyType = 'CUSTOMER';
                                            thirdPartyDialog = !thirdPartyDialog;
                                        "
                                        rounded
                                        color="ternary"
                                        elevation="0"
                                        class="ml-2"
                                        :disabled="disabledThirdPartyCompany()"
                                        size="small"
                                    >
                                        Client
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <AccountableAccountVue
                                        :title="subAccountableAccountTitle"
                                        :showLabel="true"
                                        :showValidation="false"
                                        :companyId="selectedCompany.id"
                                        inAccountableAccountType="Selected"
                                        :embeddedInput="true"
                                        :editAccountableAccount="true"
                                        :inAccountableAccountNames="subSelectedAccountableAccounts"
                                        :defineThirdParty="true"
                                        @close="closeAccountableAccount"
                                        @select-accountableAccount="setAccountableAccount($event)"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <div class="d-flex align-center">
                                                <v-btn
                                                    rounded
                                                    color="ternary"
                                                    elevation="0"
                                                    class="ml-2"
                                                    :disabled="disabledThirdPartyCompany()"
                                                    @click="socialAccountableAccount()"
                                                    v-bind="props"
                                                    size="small"
                                                    >Social</v-btn
                                                >
                                                <v-btn
                                                    rounded
                                                    color="ternary"
                                                    elevation="0"
                                                    class="ml-2"
                                                    :disabled="disabledThirdPartyCompany()"
                                                    @click="stateAccountableAccount()"
                                                    v-bind="props"
                                                    size="small"
                                                    >Etat</v-btn
                                                >
                                                <v-btn
                                                    rounded
                                                    color="ternary"
                                                    elevation="0"
                                                    class="ml-2"
                                                    :disabled="disabledThirdPartyCompany()"
                                                    @click="miscelleanousAccountableAccount()"
                                                    v-on="props.on"
                                                    size="small"
                                                    >Autres</v-btn
                                                >
                                            </div>
                                        </template>
                                    </AccountableAccountVue>
                                </v-col>
                                <v-col>
                                    <v-btn
                                        rounded
                                        color="ternary"
                                        elevation="0"
                                        class="ml-2"
                                        :disabled="disabledZTillReconciliation"
                                        v-if="showZTillReconciliation"
                                        @click="showZTillDialog = true"
                                        size="small"
                                        >Z de caisse</v-btn
                                    >
                                </v-col>
                                <v-col>
                                    <v-btn
                                        rounded
                                        color="ternary"
                                        elevation="0"
                                        class="ml-2"
                                        :disabled="disabledAutoSalesReconciliation"
                                        v-if="!declareSalesInvoices"
                                        @click="
                                            autoSalesReconciliationDialog =
                                                !autoSalesReconciliationDialog
                                        "
                                        :loading="autoSalesReconciliationLoading"
                                        size="small"
                                    >
                                        Encaissement
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon icon="$dots_vertical" v-bind="props" />
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="disabledWithoutInvoice"
                                                @click="onWithoutInvoiceClick"
                                            >
                                                <v-list-item-title
                                                    >Justificatif manquant</v-list-item-title
                                                >
                                            </v-list-item>
                                            <v-list-item
                                                v-if="showTransactionType"
                                                :disabled="disabledTransactionType"
                                                @click="openTransactionTypeDialog(null)"
                                            >
                                                <v-list-item-title
                                                    >Type de transaction</v-list-item-title
                                                >
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="
                                                    !account ||
                                                    !account.id ||
                                                    account.id === 'ALL' ||
                                                    !selected.length
                                                "
                                                @click="analyseBankTransactionWordings()"
                                            >
                                                <v-list-item-title
                                                    >Analyser les libellés</v-list-item-title
                                                >
                                            </v-list-item>
                                            <v-divider />
                                            <v-list-item
                                                :disabled="!showDeallocation"
                                                @click="showDeallocateDialog = true"
                                                :color="showDeallocation ? '' : 'error'"
                                            >
                                                <v-list-item-title
                                                    >Retirer l'affectation</v-list-item-title
                                                >
                                                <template v-slot:append>
                                                    <v-icon size="small">$delete</v-icon>
                                                </template>
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="disabledDeleteBT"
                                                @click="showDeleteBankTransactionsDialog = true"
                                                :color="disabledDeleteBT ? '' : 'error'"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon size="small">$delete</v-icon>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </template> -->

                <template v-slot:no-data>Aucune écriture trouvée</template>
                <template v-slot:item="props">
                    <tr
                        style="cursor: pointer"
                        data-cy="accountingLog-document"
                        v-for="(al, index) in props.item.accountingLines"
                        :key="props.item.id + '_' + index"
                        @click="onItemClick(props.item)"
                    >
                        <!-- <td class="text-center" :style="getCellStyle(index, 'width: 64px;')">
                            <v-checkbox
                                @update:model-value="props.select($event)"
                                :ripple="false"
                                :model-value="props.isSelected"
                            />
                        </td> -->
                        <!-- <td class="pl-2 pr-2 text-center" :style="getCellStyle(index)" v-if="documentType==='ALL'">
                        <b v-if="index===0">{{ $t("document.shortType."+props.item.type||"UNKNOWN") }}</b>
                    </td> -->
                        <td class="px-0 text-center" :style="getCellStyle(index)">
                            {{ formatDate(al.date) }}
                        </td>
                        <td class="pl-2 pr-2 text-left" :style="getCellStyle(index)">
                            {{ getAccountableAccountTitle(al) }}
                        </td>
                        <td :style="getCellStyle(index)">
                            <v-chip
                                label
                                color="tagFree"
                                class="mr-1"
                                v-if="al.tag"
                                size="x-small"
                                >{{ al.tag.name }}</v-chip
                            >
                            <template v-if="al.tags">
                                <v-chip
                                    label
                                    class="mr-1"
                                    v-for="(tag, tagIndex) in al.tags"
                                    :key="tagIndex"
                                    size="x-small"
                                    ><span :style="'color:' + labelTextColor + ';'">{{
                                        tag.name
                                    }}</span></v-chip
                                >
                            </template>
                            {{ al.wording }}
                        </td>
                        <td class="text-left" :style="getCellStyle(index)">
                            {{ getThirdPartyName(al) }}
                        </td>
                        <td class="px-0 text-right" :style="getCellStyle(index)">
                            <span v-if="al.amountSigned > 0">{{
                                newCommonFormatCurrency(Math.abs(al.amountSigned), undefined)
                            }}</span>
                        </td>
                        <td class="pl-0 pr-2 text-right" :style="getCellStyle(index)">
                            <span v-if="al.amountSigned < 0">{{
                                newCommonFormatCurrency(Math.abs(al.amountSigned), undefined)
                            }}</span>
                        </td>
                    </tr>
                </template>
            </oss-data-table>
            <!-- <AccountingItemEdition
            v-model="miscellaneousOperationDialog"
            :companyId="selectedCompany.id"
            @upsert="refresh()"
            v-if="miscellaneousOperationDialog"
        ></AccountingItemEdition> -->
            <oss-dialog
                v-model="miscellaneousOperationDialog"
                :actions="actionsMiscellaneousOperation"
                width="90vw"
            >
                <AccountingItemEdition2
                    v-if="miscellaneousOperationDialog"
                    :companyId="selectedCompany.id"
                    :actions="actionsMiscellaneousOperation"
                    @upsert="refresh()"
                />
            </oss-dialog>
        </template>
    </div>
</template>

<script lang="ts">
import { BankBase } from "../BankBase";
import OssFilterBar from "../ossComponents/ossFilterBar.vue";
import AccountingItemEdition2 from "@/views/accounting/accountingItem/Edition.vue";

import { getUserDisplayName } from "../../services/userServices";

import BANKTRANSACTIONS_FILTER_QUERY from "../../graphql/bankTransaction/FilterBankTransactionsLog.gql";
import { computeNotJustifiedAmountSigned } from "../../services/bankTransactionServices";
import { DialogAction } from "@/services/dialogAction";
import { Component, Prop, Model, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        OssFilterBar,
        AccountingItemEdition2,
    },
})
export class AccountingLogBank extends BankBase {
    @Prop({ default: null }) documentTypes: any;
    // @Prop({ default: "ALL" }) value;

    @Model() value;

    get type() {
        return this.value;
    }

    set type(event) {
        this.value = event;
    }

    @Watch("type")
    onTypeChanged() {
        const values = this.type.split("#");
        if (values.length === 2) {
            this.selectedAccount = values[1];
        } else {
            this.selectedAccount = "ALL";
        }
    }

    miscellaneousOperationDialog: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    // getQuery() {
    //     return DOCUMENTS_FILTER_QUERY
    // }

    get minDate() {
        if (this.selectedAccountingPeriod) {
            return this.selectedAccountingPeriod.start;
        }
        return null;
    }

    get maxDate() {
        if (this.selectedAccountingPeriod) {
            return this.selectedAccountingPeriod.end;
        }
        return null;
    }

    allDocumentStatus = ["VALIDATED"];

    get totalDebit() {
        let total = 0;
        for (const bt of this.items) {
            for (const al of bt.accountingLines) {
                if (al.amountSigned > 0) total += al.amountSigned;
            }
        }
        return total;
    }

    get totalCredit() {
        let total = 0;
        for (const bt of this.items) {
            for (const al of bt.accountingLines) {
                if (al.amountSigned < 0) total -= al.amountSigned;
            }
        }
        return total;
    }

    getQuery() {
        return BANKTRANSACTIONS_FILTER_QUERY;
    }

    getAccountableAccountTitle(item) {
        let title = "";
        if (item && item.accountableAccount) {
            title = item.accountableAccount.displayName || item.accountableAccount.name;
            if (title === "INTERNAL_LINK") {
                return "Lien interne";
            }
            if (title) {
                title += " - ";
            }
            title += item.accountableAccount.description;
        }
        // if (item) {
        //     const aaName = item.thirdPartyAccountableAccount ? item.thirdPartyAccountableAccount.name : (item.accountingLine.accountableAccount || "");
        //     return aaName !== "INTERNAL_LINK" ? aaName : '-'
        // }
        return title;
    }

    getThirdPartyName(item) {
        let title = "";
        if (item.thirdPartyCompany) {
            title = item.thirdPartyCompany.name;
        }
        if (item.user) {
            if (title) title += " - ";
            title += getUserDisplayName(item.user);
        }
        if (item.bankAccount) {
            if (title) title += " - ";
            title += item.bankAccount.name;
        }
        return title;
    }

    beforeMount() {
        this.onlyAccounting = true;
        this.amountType = "ALL";
        this.selectedAccount = "ALL";
        this.onTypeChanged();
        this.finishMounted();
    }

    finishReadItem(item) {
        if (!item.finishReadItemDone) {
            item.finishReadItemDone = true;
            const notJustifiedAmountSigned = computeNotJustifiedAmountSigned(
                item,
                item.accountingLines,
            );
            if (!item.version || item.version === 1) {
                item.accountingLines.splice(0, 0, {
                    id: "",
                    accountableAccount: { name: "512000", description: "Banque" },
                    wording: item.wordingOriginal || item.wordingDisplay,
                    date: item.dateDebit,
                    amountSigned: item.amount,
                    bankAccount: item.account,
                });
            }

            if (Math.abs(notJustifiedAmountSigned) >= 1e-2) {
                item.accountingLines.push({
                    id: "",
                    accountableAccount: { name: "471000", description: "Compte d'attente" },
                    wording: item.wordingOriginal || item.wordingDisplay,
                    date: item.date.dateDebit,
                    amountSigned: -notJustifiedAmountSigned,
                });
            }
        }
    }

    getCellStyle(index, initialStyle = "") {
        let style = initialStyle || "";

        if (index === 0) {
            style += "border-top: solid 12px #F1F1F1 !important;";
        }
        // if (transparent) {
        //     style+=  "background-color: #F1F1F1 !important; border-bottom: solid 1px #F1F1F1 !important;"
        // }
        return style;
    }
}

export default toNative(AccountingLogBank);
</script>
